import type { EveMessage } from 'eve/vue'

export function docueAgentMessageInputPrompts(message: EveMessage) {
  return message.parts.flatMap((part) => {
    const interaction = part.type === 'tool' ? part.interaction : part.type === 'interaction' ? part : undefined
    if (!interaction || interaction.request.kind === 'sign-in')
      return []

    // Settled approvals stay in eve's history, but are no longer prompts to show.
    // A submitted or refused answer can still leave the interaction open.
    if (interaction.request.kind === 'approval' && interaction.status === 'settled')
      return []

    return [{
      interactionId: interaction.interactionId,
      isToolConfirmation: interaction.request.kind === 'approval',
      pending: interaction.status === 'open' && !interaction.answer,
      request: interaction.request,
      response: interaction.answer,
      toolInput: interaction.call?.input,
      toolName: interaction.call?.name ?? '',
    }]
  })
}
